const setResumeCoverLetter = (coverLetter) => ({
    type: 'SET_RESUME_COVER_LETTER',
    coverLetter,
});

export default setResumeCoverLetter;
